<nav class="navigation" *ngIf="items.length && setNavItems()">
  <a
    class="navigation__item"
    [ngClass]="{ 'navigation__item--active': item.isActive }"
    *ngFor="let item of navItems"
    routerLinkActive="navigation__item--active"
    [routerLink]="item.url"
  >
    <img *ngIf="item?.iconUrl" [src]="item.iconUrl" [alt]="item.title" />
    <span *ngIf="!item?.iconUrl"> {{ item.title }}</span>
  </a>
</nav>
